module.exports = __webpack_public_path__ + "media/packs/images/missing-thumb-7c89405d212ec4ac68f9a877bd0dc4e7.png";